let handler = null;
export function registerLeaveHandler(next) {
    handler = next;
    return () => {
        if (handler === next)
            handler = null;
    };
}
/** Resolves true when it's fine to leave (nothing unsaved, or the user chose to). */
export function requestLeave(reason) {
    return handler ? handler(reason) : Promise.resolve(true);
}
